import type { ReactNode } from 'react';
import { FieldError } from './FieldError';

export function FieldRow({
  id,
  label,
  srLabel,
  tooltip,
  help,
  error,
  children,
}: {
  id: string;
  label: string;
  srLabel?: string;
  tooltip?: string;
  help?: ReactNode;
  error: string | null;
  children: ReactNode;
}) {
  return (
    <div className="hsab-calc__field-row" data-invalid={error ? 'true' : undefined}>
      <div className="hsab-calc__field-label-row">
        {/*
          Bug found 2026-09-09 comparing HSA Savings against the live
          production calculator: every visible field label was missing on
          screen. Root cause was here — `srLabel`'s own doc comment
          (types.ts) says it's for "when the visible label is not the
          accessible name," but this swapped to sr-only text and dropped the
          visible label entirely whenever srLabel was set. `aria-label`
          overrides the announced name while the real label stays on screen,
          which is what "not the accessible name" actually means.
        */}
        <label htmlFor={id} className="hsab-calc__field-label" aria-label={srLabel}>
          {label}
        </label>
        {tooltip && (
          <span className="hsab-calc__tooltip" tabIndex={0} aria-label={tooltip}>
            ?
            <span className="hsab-calc__tooltip-text" role="tooltip">
              {tooltip}
            </span>
          </span>
        )}
      </div>
      {children}
      {help && <p className="hsab-calc__field-help">{help}</p>}
      <FieldError id={id} error={error} />
    </div>
  );
}
